import Image from 'app/Components/Shared/Image/image';
import React, {useState} from 'react';
import BtnSelect from '../../../Shared/Buttons/BtnSelect';
import ReactTooltip from 'react-tooltip';
import {CopyToClipboard} from 'react-copy-to-clipboard';
import CopyIcon from '../EsimIcons/CopyIcon';
import BottomLinks from '../BottomLinks';
import { getThemeColor } from 'app/utilities/theme/ThemeColorEnum';
import { ThemeColorEnum } from 'app/utilities/theme/ThemeColorEnum';  
const ConnectionCodePage = (props) => {
  const [isIosInstruction, setIosInstruction] = useState(false);
  const [isAndroidInstruction, setAndroidInstruction] = useState(false);
  const [smdp, setSmdp] = useState(props.currentPhone?.qrCodeData?.smdp);
  const [accessCode, setAccessCode] = useState(props.currentPhone?.qrCodeData?.accessCode);
  const [copied, setCopied] = useState(false);
  let instructionsAndroid = props.iContent?.instructionsAndroidActivationCode?.value;
  let instructionsIos = props.iContent?.instructionsIosActivationCode?.value;
  
  return (
    <div className='connect-code-container'>
      <p className='connect-code-main-title'>הפעלת eSIM עם קודי הפעלה</p>
      <p className='connect-code-sub-title'>איזה מכשיר יש לכם?</p>
      <div className='buttons-change-mode-container'>
        <BtnSelect
          imgElement={<Image className='icon-apple' src={require('../EsimIcons/icon-24-apple.svg')} />}
          text={'IOS'}
          onClick={() => {
            setIosInstruction(true);
            setAndroidInstruction(false);
          }}
          border={`${isIosInstruction ? 'selected' : 'unselected'}`}
        />
        <BtnSelect
          imgElement={<Image className='icon-android' src={require('../EsimIcons/icon-24-android.svg')} />}
          text={'אנדרואיד'}
          onClick={() => {
            setAndroidInstruction(true);
            setIosInstruction(false);
          }}
          border={`${isAndroidInstruction ? 'selected' : 'unselected'}`}
        />
      </div>
      <hr />
      {!isIosInstruction && !isAndroidInstruction ? null : (
        <>
          <div className='instruction-area'>
            {isIosInstruction && (
              <ul>
                {instructionsIos?.map((e, i) => {
                  return (
                    <li type='1' key={i}>
                      {e}
                    </li>
                  );
                })}
              </ul>
            )}
            {isAndroidInstruction && (
              <ul>
                {instructionsAndroid?.map((e, i) => {
                  return (
                    <li type='1' key={i}>
                      {e}
                    </li>
                  );
                })}
              </ul>
            )}
          </div>
          <div className='data-connection-code-container'>
            <p className='main-title-connect-code-text'>קודי הפעלה לקו</p>
            <p className='phone-number-connect-code-text'>{props.currentPhone?.phoneNumber}</p>
            <ReactTooltip arrowColor={getThemeColor(ThemeColorEnum.PRIMARY, '#7421ca')} place={'top'} className='tooltip-style' target={'smdp'} clickable={true}>
              העתק
            </ReactTooltip>
            <CopyToClipboard
              text={smdp}
              onCopy={() => {
                setCopied(true);
              }}>
              <div className='inside-input-container'>
                <label className='label-text'>כתובת +SM-DP:</label>
                <span className='text-ellipsis'>{smdp} </span>
                <CopyIcon className='copy-icon' data-tip='smdp' />
              </div>
            </CopyToClipboard>
            <ReactTooltip arrowColor={getThemeColor(ThemeColorEnum.PRIMARY, '#7421ca')} place={'top'} className='tooltip-style' target={'smdp'} clickable={true}>
              העתק
            </ReactTooltip>
            <CopyToClipboard text={accessCode} onCopy={() => setCopied(true)}>
              <div className='inside-input-container'>
                <label className='label-text'>קוד הפעלה:</label>
                <span className='text-ellipsis'>{accessCode} </span>
                <CopyIcon className='copy-icon' data-tip='accessCode' />
              </div>
            </CopyToClipboard>
          </div>
          <BottomLinks context={props.context} iContent={props.iContent} setPopUp={(isShowPopUp) => props.setPopUp(isShowPopUp)} />
        </>
      )}
    </div>
  );
};

export default ConnectionCodePage;
